
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mode-optimization",
      function () {
        return require("private-next-pages/mode-optimization.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mode-optimization"])
      });
    }
  